import { render } from "./FAQ.vue?vue&type=template&id=d5882ae0"
import script from "./FAQ.vue?vue&type=script&lang=js"
export * from "./FAQ.vue?vue&type=script&lang=js"

import "./FAQ.vue?vue&type=style&index=0&id=d5882ae0&lang=css"

import exportComponent from "/n/www/reich-ages.rc.hms.harvard.edu/AGES/Front/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__